export const name = "STRPOS";
export const summary = `Finds the position of the first occurrence of a subvalue inside another value.`;
export const reference = `
## STRPOS

Finds the position of the first occurrence of a subvalue inside another value.

\`\`\`
STRPOS(value, subvalue)
\`\`\`

### Description

Takes two \`STRING\` or \`BYTES\` values. Returns the 1-based position of the first occurrence of \`subvalue\` inside \`value\`. Returns \`0\` if \`subvalue\` isn't found.

This function supports specifying collation.


### Return type

\`INT64\`


### Examples



\`\`\`
SELECT STRPOS('foo@example.com', '@') AS example

/*---------*
 | example |
 +---------+
 | 4 |
 *---------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
